import { Button, Form, Row, Space, theme } from "antd";
import FormItem, { createRegexRule } from "../../../form/form-item";
import { useCallback, useEffect } from "react";
import { useGetInsuranceAddressesQuery } from "../../../../../api/plamo-api";
import PlamoApiWithSaveNotifications from "../../../util/with-save-notification";

import { DeleteOutlined } from "@ant-design/icons";
import { AdvancedForm, useAdvancedFormContext } from "../../../form/advanced-form";

const { useCreateInsuranceAddressWithSaveNotificationMutation, useUpdateInsuranceAddressWithSaveNotificationMutation, useDeleteInsuranceAddressWithSaveNotificationMutation } = PlamoApiWithSaveNotifications;


const AddAddressButton = ({ onClick }) => {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <Button onClick={onClick} disabled={advancedFormContext.readOnly}>
      Weiteren Adresse hinzufügen
    </Button>
  )
}

const DeleteButton = ({ onClick }) => {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <Button icon={<DeleteOutlined />} onClick={onClick} disabled={advancedFormContext.readOnly} />
  )
}

function InsuranceAddresses({ insuranceId }) {
  const [form] = Form.useForm();
  const { data } = useGetInsuranceAddressesQuery({ f: JSON.stringify({ "insurance.id": { c: "EQ", v: insuranceId }}), st: JSON.stringify({ id: 'asc' }) }) as any
  const [ createInsuranceAddress, { isLoading: isCreatingRelative } ] = useCreateInsuranceAddressWithSaveNotificationMutation();
  const [ updateInsuranceAddress, { isLoading: isUpdatingRelative } ] = useUpdateInsuranceAddressWithSaveNotificationMutation();
  const [ deleteInsuranceAddress, { isLoading: isDeletingRelative } ] = useDeleteInsuranceAddressWithSaveNotificationMutation();
  //const relatives = useMemo(() => data.items || [], [data])

  const isLoading = isCreatingRelative || isUpdatingRelative || isDeletingRelative;

  const { token } = theme.useToken();

  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  useEffect(() => {
      form.setFieldsValue(data)
  }, [form, data])

  const onFinish = useCallback(async (values: any) => {
    console.log('On finish', values);
    const promisesCreateUpdate = values.items.map(i => {
      console.log("Creating / updating address", i);
      if(i.id) {
        return updateInsuranceAddress(i);
      } else {
        return createInsuranceAddress(i);
      }
    })

    const promisesDelete = data.items.filter(i => !values.items.find(i2 => i.id === i2.id)).map(i => deleteInsuranceAddress(i));
    
    await Promise.all([...promisesCreateUpdate, ...promisesDelete]);
  }, [createInsuranceAddress, updateInsuranceAddress, deleteInsuranceAddress, data]);

  return (<AdvancedForm form={form} name="relatives" style={formStyle} onFinish={onFinish} originalValues={data} isLoading={isLoading}>
    <Form.List name="items">
      {(fields, { add, remove }, { errors }) => <>{
        fields.map((field, index) => { return <>
          <Row><h3>Adresse { index + 1 } <DeleteButton  onClick={() => remove(index)} /></h3></Row>
          <Row gutter={24}>
            <FormItem field={field} fieldName="types" label="Budgets" type="enum" typeData={{ options: [{ label: "Entlasungsbetrag", value: "supportAmount" }, { label: "Verhinderungspflege", value: "absenceCare" }, { label: "Kurzzeitpflege", value: "shortTermCare" }, { label: "Umwandlung", value: "conversion" }, { label: "Haushaltshilfe", value: "domesticAid" }, { label: "Beratungsbesuche", value: "counseling"}], multiple: true }} />
          </Row>
          <Row gutter={24}>
            <FormItem field={field} fieldName="recipient1" label="Empfängerzeile 1" />
            <FormItem field={field} fieldName="recipient2" label="Empfängerzeile 2" />
          </Row>
          <Row gutter={24}>
            <FormItem field={field} fieldName="street" label="Straße" />
            <FormItem field={field} fieldName="housenumber" label="Hausnummer" />
            <FormItem field={field} fieldName="zipCode" label="PLZ" rules={[createRegexRule(/^\d{5}$/, 'Keine gültige PLZ')]} />
            <FormItem field={field} fieldName="city" label="Ort" />
          </Row>
        </>})}
        <div style={{ textAlign: 'right', marginBottom: '24px' }}>
          <Space size="small">
            <AddAddressButton onClick={() => add({ insuranceId })} />
          </Space>
        </div>
        </>
      }
    </Form.List> 
    </AdvancedForm>)
}

export default InsuranceAddresses;